/**************************************************
 * Nombre:       Seccion_Depositos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import Dialogo_Deposito from "../Dialogos/Dialogo_Deposito";
import {ESTADOSPRENDA} from "../../Constantes";
import Dialogo_Deposito_Ver from "../Dialogos/Dialogo_Deposito_Ver";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {obtenerSaldo} from "../../CodNegocio/Saldos/obtenerSaldo";

const Seccion_Depositos = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'depositos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Deposito,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Deposito_Ver,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const [valDepositos, setValDepositos] = useState(0)

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrirVer(data)
                break
        }
    }


    useEffect(() => {

        obtenerSaldo().then((dox) => {
            setValDepositos(dox)
        })

    }, [])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVer/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Saldo Actual: ${formatoMonedaTabla(valDepositos)}`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        textoAgregar={'Movimiento Nuevo'}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Depositos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombreUsuario'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'mensaje',
        titulo: 'idUsuario',
        tipo: CASILLA_TITULO_DATO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPRENDA
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]